<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <div v-if="id === null || id === undefined">
      <a-card class="m-wrong">
        <m-anim
          :options="notfound"
          class="anim"
          :height="getScreen ? 200 : 500"
          :width="getScreen ? 200 : 500"
        ></m-anim>
        <h3>>Not Found</h3>
        <p>
          Return to the previous page and make the selection manifest again!
        </p>
        <a-button type="primary" block>
          <router-link to="/pembayaranPiutang">
            <a-icon type="rollback" />&nbsp; Return
          </router-link>
        </a-button>
      </a-card>
    </div>
    <div v-else>
      <a-config-provider :locale="getLocalConfigProvider()">
        <a-row :gutter="8">
          <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
            <a-card :loading="loading" class="margin-bottom">
              <div slot="title">
                Manifest Account Receivables Employee 
                <small class="m-display-block m-text-small">{{
                  data.header.no_trans
                }}</small>
              </div>

              <a-popover slot="extra" trigger="click" placement="bottom">
                <span slot="title">Select Action</span>
                <ul class="m-list-wrapper bordered" slot="content">
                  <!-- <li>
                    <a-button
                      type="primary"
                      size="small"
                      icon="printer"
                      block
                      ghost
                      @click="handlePrint"
                      class="m-display-block"
                      >Manifest</a-button
                    >
                  </li> -->
                  <li v-if="getAuth.username == data.header.tlc_create">
                    <!-- <a-button-group> -->
                    <a-button
                      :disabled="
                        !(
                          data.last_status == 'Revised' &&
                          getAuth.username == data.header.tlc_create
                        )
                      "
                      @click="handleEdit"
                      type="dashed"
                      size="small"
                      icon="edit"
                      block
                      class="m-display-block"
                      >Edit</a-button
                    >
                    <!-- </a-button-group> -->
                  </li>
                </ul>
                <a-button icon="more">Action</a-button>
              </a-popover>

              <div class="m-card-body">
                <ul class="m-list-wrapper bordered">
                  <li>
                    <span class="m-list-title" for>Date Create</span>
                    <span class="m-list-desc"
                      >{{
                        data.header.create_dt
                          ? moment(
                              data.header.create_dt,
                              getStandartFormatDate
                            ).format(getDefaultDateFormat)
                          : "-"
                      }}
                    </span>
                  </li>
                  <li>
                    <span class="m-list-title" for>Periode</span>
                    <span class="m-list-desc">{{data.header.periode ? moment(data.header.periode,'YYYY-MM').format('MMMM YYYY') : '-'}}</span>
                  </li>
                  <li>
                    <span class="m-list-title" for>Description</span>
                    <span class="m-list-desc">{{data.header.description}}</span>
                  </li>
                  <li>
                    <span class="m-list-title" for>Note</span>
                    <span class="m-list-desc">{{data.header.note}}</span>
                  </li>
                  <!-- <li>
                    <span class="m-list-title" for>Nominal</span>
                    <span class="m-list-desc">{{ formatCurrency("IDR",data.header.nominal) }}</span>
                  </li> -->
                  <li>
                    <span class="m-list-title" for>Document</span>
                    <span class="m-list-desc margin-top">
                      <a-button
                        class="margin-top ant-menu-submenu ant-menu-submenu-selected"
                        icon="download"
                        size="default"
                        @click="handlePreview(data.header.file_url)"
                      >View Document</a-button>
                      
                    </span>
                  </li>
                </ul>
              </div>
            </a-card>

            <a-collapse
              class="margin-top"
              activeKey="1"
            >
              <a-collapse-panel key="1">
                <h4 slot="header" class="margin-remove">Detail Account Receivables Employee</h4>
                <a-table
                  rowKey="piutang_karyawan_dtl_id"
                  id="piutang_karyawan_dtl"
                  :columns="columns"
                  :dataSource="data.detail"
                  :pagination="pagination"
                  size="small"
                  bordered
                  :scroll="{ x: 600 }"
                >
                  <div slot="no" slot-scope="text, record, index">
                    {{index+1}}
                  </div>
                  <div slot="nama" slot-scope="text, record, index">
                    <span>{{record.end_user}}</span><br/>
                    <a href="#" @click="handlelinkpiutang(record.piutang_karyawan_id)">{{ record.piutang_karyawan_no }}</a>
                  </div>
                  <div slot="val_i" slot-scope="text, record, index">
                    <span>{{formatCurrency('IDR',record.value_installment)}}</span>
                  </div>
                  <div slot="val_b" slot-scope="text, record, index">
                    <span>{{formatCurrency('IDR',record.remaining_balance)}}</span>
                  </div>
                  <div slot="footer" class="padding-all">
                    <a-row type="flex">
                      <a-col :span="7" :order="1" class="m-text-align left"
                        >Grand Total</a-col
                      >
                      <a-col
                        :span="7"
                        :order="2"
                        class="m-text-align left m-text-bold"
                      >
                        <CurrencyJustified
                          :currencyValue="'IDR'"
                          :valueNumber="data.header.grand_total"
                        />
                      </a-col>
                      <a-col
                        :span="3"
                        :order="3"
                        class="m-text-align left m-text-bold"
                      ></a-col>
                    </a-row>
                  </div>
                </a-table>
              </a-collapse-panel>
            </a-collapse>

            <a-card
              class="margin-top"
              :loading="loading"
              v-if="data.jenis === 'Verifikator'"
            >
              <a-form :form="form">
                <a-form-item label="Note">
                  <a-textarea
                    placeholder="Write the note here ... "
                    :rows="4"
                    v-decorator="['catatan']"
                  />
                </a-form-item>
                <a-form-item label="Actions">
                  <a-select
                    showSearch
                    v-decorator="['aksi', { rules: [{ required: true }] }]"
                  >
                    <a-select-option v-for="item in data.aksi" :key="item.aksi">{{
                      item.aksi
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item :wrapper-col="{ span: 24 }">
                  <a-button
                    @click="handleActionConfirm"
                    :loading="loadingSave"
                    block
                    type="primary"
                    html-type="submit"
                    >Save</a-button
                  >
                </a-form-item>
              </a-form>
            </a-card>

            <a-card
              class="margin-top"
              :loading="loading"
              v-if="data.jenis === 'Approve'"
            >
              <a-form :form="form">
                <a-form-item label="Note">
                  <a-textarea
                    placeholder="Write the note here ... "
                    :rows="4"
                    v-decorator="['catatan']"
                  />
                </a-form-item>
                <a-form-item label="Actions">
                  <a-select
                    showSearch
                    v-decorator="['aksi', { rules: [{ required: true }] }]"
                  >
                    <a-select-option v-for="item in data.aksi" :key="item.aksi">{{
                      item.aksi
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item :wrapper-col="{ span: 24 }">
                  <a-button
                    @click="handleActionConfirm"
                    :loading="loadingSave"
                    block
                    type="primary"
                    html-type="submit"
                    >Save</a-button
                  >
                </a-form-item>
              </a-form>
            </a-card>

            <a-card
              class="margin-top"
              v-if="data.jenis === 'Transfer' && status_transfer"
            >
              <div slot="title">
                Manifest Actions &nbsp;<i
                  v-if="data.jenis == 'Transfer' && !status_transfer"
                  style="color: red !important"
                  >(Funding has not been set)</i
                >
              </div>
              <div class="m-text-align right margin-remove" slot="extra">
                <h5 class="m-text-align right margin-remove">
                  remaining balance
                </h5>
                <a-tag color="green" class="m-text-align right margin-remove">{{
                  formatCurrency(data.currency, sisa_tf)
                }}</a-tag>
              </div>
              <template v-if="!(data.jenis == 'Transfer' && !status_transfer)">
                <a-form :form="formTransfer">
                  <a-row :gutter="16">
                    <a-form-item label="Status">
                      <a-select
                        @change="onChangeStatus"
                        v-decorator="[
                          'aksi',
                          {
                            rules: [{ required: true }],
                            initialValue: data.aksi[0].aksi,
                          },
                        ]"
                      >
                        <a-select-option v-for="da in data.aksi" :key="da.aksi">{{
                          da.aksi
                        }}</a-select-option>
                      </a-select>
                    </a-form-item>

                    <a-form-item v-if="reqFileTf" label="Transfer Date">
                      <a-date-picker
                        placeholder="Select Date"
                        :format="dateFormat"
                        v-decorator="['tgl_tf', { rules: [{ required: true }] }]"
                      />
                    </a-form-item>

                    <a-form-item v-if="reqFileTf" label="Upload Bukti Transfer">
                      <a-upload
                        :fileList="fileList"
                        :showUploadList="true"
                        :disabled="fileList.length > 0"
                        v-decorator="[
                          'file_transfer',
                          { rules: [{ required: reqFileTf }] },
                        ]"
                        accept=".jpg, .png, .pdf"
                        :remove="handleRemove"
                        :beforeUpload="beforeUpload"
                      >
                        <a-button> <a-icon type="upload" />Select File </a-button>
                      </a-upload>
                    </a-form-item>

                    <a-form-item v-if="reqFileTf" label="Transfer Value">
                      <a-checkbox
                        :defaultChecked="true"
                        @change="onchangeNilaiTf"
                        :checked="checkTransferValue"
                        >Transfer value according to remaining balance</a-checkbox
                      >
                      <a-input-number
                        :min="0.1"
                        :max="sisa_tf"
                        class="m-display-block" style="width:150px"
                        v-decorator="[
                          'value_transferan',
                          {
                            rules: [{ required: true }],
                            initialValue: temp_sisa_tf,
                          },
                        ]"
                        :disabled="disableNilaiTf"
                        @keydown="onlyNumber"
                        :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                    </a-form-item>

                    <a-form-item label="Note">
                      <a-textarea
                        placeholder="Write the note here ... "
                        :rows="4"
                        v-decorator="[
                          'catatan',
                          { rules: [{ required: false }] },
                        ]"
                      />
                    </a-form-item>
                  </a-row>
                  <a-form-item :wrapper-col="{ span: 24 }">
                    <a-button
                      @click="handleActionConfirm"
                      block
                      type="primary"
                      html-type="submit"
                      >Save</a-button
                    >
                  </a-form-item>
                </a-form>
              </template>
            </a-card>
          </a-col>

          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <!-- <a-card :loading="loading" 
            :class="getScreen ? 'margin-top' : ''">
              <div slot="title">Evidence of Transfer</div>
              <div>
                <a-alert
                  v-if="data.bukti_transfer.length <= 0"
                  type="error"
                  message="No evidence of transfer was uploaded"
                  banner
                />
                <a-list
                  itemLayout="horizontal"
                  :dataSource="data.bukti_transfer"
                  v-else
                >
                  <Empty
                    v-if="
                      data.bukti_transfer
                        ? data.bukti_transfer.length <= 0
                        : data.bukti_transfer
                    "
                  />
                  <a-list-item slot="renderItem" slot-scope="item">
                    <a-list-item-meta>
                      <div slot="title" class="m-display-flex space-between">
                        <h3 class="margin-remove">
                          {{ moment(item.tgl_tf).format(getDefaultDateFormat) }} | {{ item.user_tf }}
                        </h3>

                        <a-button
                          @click="handleViewDt(item)"
                          size="small"
                          type="default"
                          icon="eye"
                          >View</a-button
                        >
                      </div>
                      <img
                        class="m-image-icon"
                        slot="avatar"
                        :src="$serviceUrl + item.url"
                      />
                      <p slot="description" class="margin-remove">
                        {{ formatCurrency(data.mata_uang, item.value_tf) }}
                      </p>
                    </a-list-item-meta>
                  </a-list-item>
                </a-list>
              </div>
            </a-card> -->

            <a-collapse activeKey="1" :class="getScreen ? 'margin-top': ''">
              <a-collapse-panel key="1">
                <div
                  class="m-display-flex space-between align-middle"
                  slot="header"
                >
                  <h4 class="margin-remove">Status</h4>
                  <div>
                    <Status :status="data.last_status" />
                    <!-- <a-button
                      @click="historyToggle"
                      type="default"
                      size="small"
                      class="margin-right-small"
                    >
                      <a-icon type="undo" />
                    </a-button> -->
                  </div>
                </div>
                <a-timeline class="m-timeline">
                  <a-timeline-item color="green">
                    <div class="m-timeline-title">
                      Pembuat - {{ data.header.tlc_create }}
                    </div>
                    <div class="m-timeline-body">
                      <h4 class="margin-remove">
                        {{
                          moment(data.header.create_dt).format(
                            getDefaultDateFormat
                          )
                        }}
                      </h4>
                      <span class="m-text-small" v-if="data.header.note">{{
                        data.header.note
                      }}</span>
                      <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                    </div>
                    <div class="m-timeline-footer">
                      <a-tag color="green">Created</a-tag>
                    </div>
                  </a-timeline-item>
                  <a-timeline-item
                    v-for="workflow in data.status"
                    :key="workflow.step_no"
                  >
                    <div class="m-timeline-title">
                      {{ workflow.actor }} - {{ workflow.tlc }}
                    </div>
                    <div class="m-timeline-body">
                      <h4 class="margin-remove" v-if="workflow.tanggal_aksi">
                        {{
                          moment(workflow.tanggal_aksi).format(getDateTimeFormat)
                        }}
                      </h4>
                      <span class="m-text-small" v-if="workflow.remark">{{
                        workflow.remark
                      }}</span>
                      <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                    </div>
                    <div class="m-timeline-footer">
                      <Status :status="workflow.status" />
                    </div>
                  </a-timeline-item>
                </a-timeline>
              </a-collapse-panel>
            </a-collapse>

            <a-collapse
              :class="'margin-top'"
              activeKey="1"
            >
              <a-collapse-panel key="1">
                <div
                  class="m-display-flex space-between align-middle"
                  slot="header"
                >
                  <h4 class="margin-remove">Related Document</h4>
                </div>
                  <a-list
                    itemLayout="horizontal"
                    :dataSource="data.related_document"
                  >
                    <Empty
                      v-if="
                        data.related_document
                          ? data.related_document.length <= 0
                          : data.related_document
                      "
                    />
                    <a-list-item slot="renderItem" slot-scope="item">
                      <a-list-item-meta>
                        <div
                          slot="title"
                          class="m-display-flex space-between align-middle"
                        >
                          <a
                            @click="
                              handleView({
                                ...item,
                                id_manifest: item.id_manifest,
                              })
                            "
                            >{{ item.no_trans }}</a
                          >
                        </div>
                        <template slot="description">
                          <div>{{ item.description }}</div>
                          <div>{{ formatCurrency("", item.value_bkm) }}</div>
                          <div>{{ moment(item.tgl).format("DD-MM-YYYY") }}</div>
                        </template>
                      </a-list-item-meta>
                    </a-list-item>
                  </a-list>
              </a-collapse-panel>
            </a-collapse>

          </a-col> 
        </a-row>
      </a-config-provider>
    </div>

    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <div class="margin-top"></div>
      <a-divider class="margin-small" />
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
import Axios from "axios";
import { mapGetters, mapActions } from "vuex";
import Status from "@/components/Status.vue";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import lottie from "vue-lottie";
import notfound from "@/assets/anim/404.json";
import moment from "moment";
import _ from "lodash";
import ACol from "ant-design-vue/es/grid/Col";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  name: "bidBondManifest",
  components: {
    ACol,
    Status,
    "m-anim": lottie,
  },
  props: ["id", "user_pembuat"],
  mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
  data() {
    const columns = [
      {
        title: "#",
        align: "right",
        width: 50,
        scopedSlots: { customRender: "no" },
      },
      {
        title: "Name",
        width: 200,
        scopedSlots: { customRender: "nama" },
      },
      {
        title: "Installment to",
        width: 100,
        align: 'center',
        dataIndex: "installment_to",
      },
      {
        title: "Value installment",
        width: 150,
        align: 'center',
        scopedSlots: { customRender: "val_i" },
      },
      {
        title: "Remaining Balance",
        width: 150,
        align: 'center',
        scopedSlots: { customRender: "val_b" },
      },
    ];
    return {
      notfound: { animationData: notfound, loop: true },
      loading: false,
      loadingSave: false,
      data: {
        //bukti_transfer: [],
        status: [],
        header: {
          type: "",
        },
        jenis:null,
        detail: []
      },
      dateFormat: "DD-MM-YYYY",
      status_transfer: null,
      sisa_tf: 0,
      reqFileTf: true,
      fileList: [],
      checkTransferValue: true,
      temp_sisa_tf: "",
      disableNilaiTf: true,
      previewVisible: false,
      previewImage: "",
      pagination: {
        onChange: (page) => {},
        pageSize: 5,
        size: "small",
      },
      columns,
    };
  },
  beforeCreate() {
    this.formTransfer = this.$form.createForm(this);
    this.form = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStandartFormatDate",
      "getDefaultDateFormat",
      "getDateTimeFormat",
    ]),
    // grandtotal(){
    //   if(this.data.detail && this.data.detail.length>0){
    //     return _.sumBy(this.data.detail, function (val) {
    //     return Number(val.value_installment);
    //     });
    //   }else{
    //     return 0
    //   }
    // }
  },
  methods: {
    moment,
    fetchManifest() {
      Axios({
        method: "get",
        url: this.$serviceUrl + "Pembayaran_piutang",
        params: {
          tlc: this.getAuth.username,
          id_manifest: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          try {
            this.data = {
              header: response.data.header[0],
              detail: response.data.dtl_installment ? response.data.dtl_installment : response.data.dtl_payment,
              last_status: response.data.last_status,
              status: response.data.status_app,
              //bukti_transfer: response.data.buktiTransfer,
              jenis: response.data.jenis,
              aksi: response.data.aksi,
              related_document: response.data.dokumen_terkait,
              };
            this.status_transfer = response.data.status_transfer;
            this.sisa_tf = response.data.sisa_tf;
            this.temp_sisa_tf = this.sisa_tf;

            this.loading = false;
          } catch (err) {
            this.loading = false;
            this.displayMessageValue("error", err);
            this.$router.go(-1);
          }
        })
        .catch((err) => {
          if (!err.response) {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
            this.$router.go(-1);
          } else {
            this.displayMessage("denied-manifest");
            this.loading = false;
            this.$router.push({ name: "beranda" });
          }
        });
    },
    handlePreview(url) {
        window.open(this.$serviceUrl+url, "_blank");
    },
    onChangeStatus(val) {
      if (val === "Transferred") {
        this.reqFileTf = true;
      }
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        if (this.data.jenis === "Transfer") {
          this.fileList.push(file);
        } else {
          this.fileListLampiran.push(file);
        }
        return false;
      }
    },
    handleRemove(file) {
      if (this.data.jenis === "Transfer") {
        const index = this.fileList.indexOf(file);
        const newFileList = this.fileList.slice();
        newFileList.splice(index, 1);
        this.fileList = newFileList;
      } else {
        const index = this.fileListLampiran.indexOf(file);
        const newFileList = this.fileListLampiran.slice();
        newFileList.splice(index, 1);
        this.fileListLampiran = newFileList;
      }
    },
    onchangeNilaiTf(e) {
      this.disableNilaiTf = e.target.checked;
      if (e.target.checked) {
        this.cek_value = 1;
        this.checkTransferValue = true;
        this.formTransfer.setFieldsValue({ value_transferan: this.sisa_tf });
      } else {
        this.cek_value = 0;
        this.checkTransferValue = false;
      }
    },
    handleActionConfirm() {
      this.confirmMessage("confirm-save");
    },
    handleActionProcess() {
      if (this.data.jenis === "Transfer") {
        this.handleActionTransfer();
      } else {
        this.handleActionAprove();
      }
    },
    handleActionAprove() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("choose-action");
          return;
        }

        let formData = new FormData();
        formData.append("id_manifest", this.id);
        formData.append("tlc", this.getAuth.username);
        formData.append("status", values.aksi);
        formData.append("remark", values.catatan ? values.catatan : "");

        this.loadingSave = true;
        Axios({
          method: "post",
          url: this.$serviceUrl + "Pembayaran_piutang/approval",
          data: formData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "multipart/form-data",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.loadingSave = false;
            this.displayMessage("success");
            this.$router.go(0);
          })
          .catch((err) => {
            this.loadingSave = false;
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
          });
      });
    },
    handleActionTransfer() {
      this.formTransfer.validateFields((err, values) => {
        if (err) {
          return;
        }
        let formData = new FormData();
        formData.append("id_manifest", this.id);
        formData.append("tlc", this.getAuth.username);
        formData.append("status", values.aksi);
        formData.append("remark", values.catatan);

        if (this.checkTransferValue) {
          formData.append("cek_value", 1);
          formData.append("value_transfer", 0);
        } else {
          formData.append("cek_value", 0);
          formData.append("value_transfer", values.value_transferan);
        }
        formData.append(
          "tgl_transfer",
          moment(values.tgl_tf).format(this.getStandartFormatDate)
        );
        formData.append("file_transfer", values.file_transfer.file);

        this.loadingSave = true;
        Axios({
          method: "post",
          url: this.$serviceUrl + "bidbond/approval",
          data: formData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "multipart/form-data",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.loadingSave = false;
            this.displayMessage("success");
            this.$router.go(0);
          })
          .catch((err) => {
            this.loadingSave = false;
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
          });
      });
    },
    handleViewDt(file) {
      let tipe = file.url.substr(file.url.length - 3);
      if (tipe == "jpg" || tipe == "jpeg" || tipe == "png") {
        this.previewImage = this.$serviceUrl + file.url;
        this.previewVisible = true;
      } else {
        window.open(this.$serviceUrl + file.url, "_blank");
      }
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handleEdit() {
      this.$router.push({
        name: "pembayaranpiutang-edit-hrd",
        params: { id: this.id, type: "revised" },
      });
    },
    handlelinkpiutang(id){
      const route = this.$router.resolve({name: "piutangkaryawan-manifest-hrd", params: {id: id}})
        window.open(route.href, '_blank')
    }
  },
  mounted() {
    this.fetchManifest();
    Event.$on("confirmMessageReturn", this.handleActionProcess);
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.handleActionProcess);
  },
  watch: {
    id() {
      if (this.id) {
        this.fetchManifest();
        this.form = this.$form.createForm(this);
        this.formTransfer = this.$form.createForm(this);
        this.reqFileTf = true;
        this.fileList = [];
        this.checkTransferValue = true;
        this.disableNilaiTf = true;
      }
    },
  },
};
</script>

<style></style>
